import Agent from "./agent.jsx";
export const getServicesPerBarber = async (barber, serviceGroup, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(
    `/BarberService?barber=${barber}&serviceGroup=${serviceGroup}`,
    token,
    shopId,
  );
};
export const addBarberService = async (barber, service, time, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");

  const params = {
    BarberId: barber,
    ServiceId: service,
    Time: time,
  };

  return await requests.post(`/BarberService`, params, token, shopId);
};
export const removeBarberService = async (barber, service, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    Barber: barber,
    Service: service,
  };
  return await requests.del(
    `/BarberService?id=${service}&barber=${barber}`,
    token,
    shopId,
  );
};
export const editBarberService = async (barber, service, time, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    BarberId: barber,
    ServiceId: service,
    DurationMinutes: time,
  };
  return await requests.put(`/BarberService`, params, token, shopId);
};
